import { createFileRoute } from "@tanstack/react-router";

import { PayPage } from "@/features/insights/pay";

export const Route = createFileRoute("/_authenticated/intel/pay")({
  component: PayPage,
});
